var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-table',{attrs:{"options":_vm.options,"columns":_vm.columns,"data":_vm.data,"loading":_vm.loading},on:{"search":_vm.search}})
}
var staticRenderFns = []

export { render, staticRenderFns }